import { createAuthClient } from 'better-auth/react'
import { emailOTPClient } from 'better-auth/client/plugins'
import { passkeyClient } from '@better-auth/passkey/client'
import { API_URL } from './api'

export const authClient = createAuthClient({
	baseURL: API_URL,
	plugins: [emailOTPClient(), passkeyClient()],
})
